import { render, staticRenderFns } from "./ResultCompletenessTypeChangesModal.vue?vue&type=template&id=5287a9f2&"
import script from "./ResultCompletenessTypeChangesModal.vue?vue&type=script&lang=ts&"
export * from "./ResultCompletenessTypeChangesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports